<template>
  <div style="flex: 1;border: 0px solid red;">
    <!-- OBJECT -->
    <template v-if="typeof item1 === 'object' && item1">
      <object-row :item1="item1" :item2="item2" :settings="settings"></object-row>
    </template>
    <!-- ALL OTHER TYPES -->
    <div v-else :class="{'red--text': !isEqual}" style="word-break: break-word;">
      <span v-if="item1">
        {{ item1 }}
      </span>
      <span v-else-if="item1 === null">
        null
      </span>
      <span v-else-if="item1 === undefined">
        undefined
      </span>
      <span v-else-if="item1 === 0">
        0
      </span>
      <span v-else-if="item1 === false">
        false
      </span>
      &nbsp;
      <span class="grey--text" v-if="settings.showTypes">
        ({{ typeof item1}})
      </span>
    </div>
  </div>
</template>

<script>
import _ from 'lodash'
import ObjectRow from './object-row'

export default {
  props: ['item1', 'item2', 'settings'],
  name: 'row',
  components: {
    'object-row': ObjectRow
  },
  data () {
    return {
    }
  },
  computed: {
    isEqual () {
      return _.isEqual(this.item1, this.item2)
    }
  }
}
</script>

<style lang="scss" scoped>
</style>

